import { BlogPosts } from '@/components/blog/BlogPosts/BlogPosts';
import { MediaCarousel } from '@/components/media/MediaCarousel';
import { MediaInsta } from '@/components/media/MediaInsta';
import { MediaPosts } from '@/components/media/MediaPosts';
import { IMediaData } from '@/interfaces';
import blogService from '@/libs/services/blogService';
import { GetServerSideProps } from 'next';
import React from 'react'

type props = {
    mediaData: IMediaData
}
const MediaPage = ({ mediaData }: props) => {
    const mediaBannerData = mediaData?.mediaList?.media?.filter((f) => f?.is_featured === 'YES') || []
    return (<>
        <MediaCarousel mediaBannerData={mediaBannerData?.slice(0, 5)} />
        <MediaPosts mediaData={mediaData.mediaList} />
        <MediaInsta />
    </>
    )
}
export const getServerSideProps: GetServerSideProps = async (context) => {
    const pageNo = (context.query.page || 1).toString();
    const mediaList = await blogService.getMediaList(pageNo, 9)
    if (!mediaList)
        return {
            notFound: true
        }
    return {
        props: {
            mediaData: {
                mediaList: mediaList,
            }
        },
    };
};

export default MediaPage;